// @ts-nocheck


import React from 'react';
import styled from 'styled-components';
import Button from 'antd/lib/button';

import { Spoiler } from './../../../components/ui';
import Grid, { GridItem } from './../../../components/layout/Grid';
import { Card, Filter, Selects } from './../../../components';

import { ownerTypes } from './../../../lib/enum';


const { Field } = Card;
const { VehicleSelect } = Selects;

const SpoilerContent = styled.div.withConfig({ displayName: "Filter__SpoilerContent", componentId: "sc-g0c954-0" })(["padding:16px;"]);


const Buttons = styled(GridItem).withConfig({ displayName: "Filter__Buttons", componentId: "sc-g0c954-1" })(["margin:0 -10px;& .ant-btn{margin:0 10px;}"]);























const OsagoCalculationFilter = ({
  filter,
  cleanFilter,
  applyFilter
}) =>
<Spoiler label="Фильтр">
    <SpoilerContent>
      <Grid gutter="16px">
        <Filter
        initialValues={filter}
        cleanFilter={cleanFilter}
        applyFilter={applyFilter}>

          {({
          values,
          changeValue,
          cleanFilter,
          applyFilter
        }) =>
        <>
              <GridItem>
                <Field label="Гос. номер">
                  <VehicleSelect
                value={values.vehicleId}
                optionTitle={(vehicle) => vehicle.licensePlate}
                filter={{
                  ownerType: ownerTypes.self,
                  'vehicleModel.type': values['vehicleModel.type']
                }}
                onChange={(value) => changeValue('vehicleId', value)} />

                </Field>
              </GridItem>
              <Buttons fullWidth>
                <Button type="primary" onClick={applyFilter}>
                  Применить
                </Button>
                <Button type="plain" onClick={cleanFilter}>
                  Очистить
                </Button>
              </Buttons>
            </>
        }
        </Filter>
      </Grid>
    </SpoilerContent>
  </Spoiler>;


export default OsagoCalculationFilter;
